import React from "react"
import Link from "gatsby-link"
import { navigateTo } from "gatsby-link"
import styles from "./css/site.css"
import { Button } from 'react-bootstrap';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';


const ListLink = props =>
    <li>
        <Link to={props.to}>
            {props.children}
        </Link>
    </li>

const today = new Date();

export default ({ children, data, location }) =>
    <div>
        <Navbar fixedTop collapseOnSelect>
            <Navbar.Header>
                <Navbar.Brand>
                    <Link to="/">RETURN OF THE SHADOW</Link>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                <Nav pullRight>
                    <NavItem eventKey={1} onClick={ () => navigateTo('/news') }>
                        NEWS
                    </NavItem>
                    <NavItem eventKey={2} onClick={ () => navigateTo('/connect') }>
                        CONNECT
                    </NavItem>
                    <NavDropdown eventKey={3} title="GAME" id="basic-nav-dropdown">
                        <MenuItem eventKey={3.1} onClick={ () => navigateTo('/getting-started')}>GETTING STARTED</MenuItem>
                        <MenuItem eventKey={3.2} onClick={ () => navigateTo('/bookofarda')}>BOOK OF ARDA</MenuItem>
                        <MenuItem eventKey={3.3} onClick={ () => navigateTo('/races') }>RACES</MenuItem>
                        <MenuItem eventKey={3.4} onClick={ () => navigateTo('/classes')}>CLASSES</MenuItem>
                    </NavDropdown>
                    <NavItem eventKey={4} onClick={ () => navigateTo('/logs') }>
                        LOGS
                    </NavItem>
                    <NavItem eventKey={5} onClick={ () => navigateTo('/rcd') }>
                        RCD
                    </NavItem>
                    <NavItem eventKey={6} onClick={ () => navigateTo('/docs') }>
                        DOCS
                    </NavItem>
                    <NavItem eventKey={7} onClick={ () => navigateTo('/about') }>
                        ABOUT
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
        <div className="body-content">
            {children()}
        
            <div className="footer-container">
                <footer className="footer">
                    <div className="container">
                        <p className="">&copy; {today.getFullYear()} Return of the Shadow, Inc. ALL RIGHTS RESERVED. All trademarks referenced herein are the properties of their respective owners.</p>
                    </div>
                </footer>
            </div>
        </div>
    </div>

    export const query = graphql`
        query LayoutQuery {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `


// WEBPACK FOOTER //
// ./src/layouts/index.js